import { ChainId } from '../../web3.types'

export function getAlchemyRpcUrl(chainId: ChainId, apiKey: string | undefined): string | undefined {
  if (!apiKey) return undefined
  const subdomain = CHAIN_TO_ALCHEMY_SUBDOMAIN[chainId]
  if (!subdomain) return undefined
  return `https://${subdomain}.g.alchemy.com/v2/${apiKey}`
}

const _CHAIN_TO_ALCHEMY_SUBDOMAIN = {
  [ChainId.Mainnet]: 'eth-mainnet',
  [ChainId.Base]: 'base-mainnet',
  [ChainId.Optimism]: 'opt-mainnet',
  [ChainId.Arbitrum]: 'arb-mainnet',
  [ChainId.Polygon]: 'polygon-mainnet',
  [ChainId.Unichain]: 'unichain-mainnet',
  [ChainId.Monad]: 'monad-mainnet',
  [ChainId.Hyperevm]: 'hyperliquid-mainnet',
  [ChainId.Stable]: 'stable-mainnet',
  [ChainId.Worldchain]: 'worldchain-mainnet',
  [ChainId.Tempo]: 'tempo-mainnet',
  [ChainId.Katana]: 'katana-mainnet',
  [ChainId.Cronos]: 'cronos-mainnet',
  [ChainId.Robinhood]: 'robinhood-mainnet',
  [ChainId.Arc]: 'arc-mainnet',
  [ChainId.Sepolia]: 'eth-sepolia'
} as const satisfies Partial<Record<ChainId, string>>

type AlchemyChainId = keyof typeof _CHAIN_TO_ALCHEMY_SUBDOMAIN

const CHAIN_TO_ALCHEMY_SUBDOMAIN: Partial<Record<ChainId, string>> = _CHAIN_TO_ALCHEMY_SUBDOMAIN

/// See https://www.alchemy.com/docs/chains/ethereum/ethereum-api-endpoints/eth-get-logs
const ALCHEMY_BLOCK_RANGES: Record<AlchemyChainId, number> = {
  [ChainId.Mainnet]: Number.POSITIVE_INFINITY,
  [ChainId.Base]: Number.POSITIVE_INFINITY,
  [ChainId.Optimism]: Number.POSITIVE_INFINITY,
  [ChainId.Arbitrum]: Number.POSITIVE_INFINITY,
  [ChainId.Worldchain]: Number.POSITIVE_INFINITY,
  [ChainId.Polygon]: Number.POSITIVE_INFINITY,
  [ChainId.Unichain]: 10_000,
  [ChainId.Monad]: 1_000,
  [ChainId.Hyperevm]: 10_000,
  [ChainId.Stable]: 10_000,
  [ChainId.Tempo]: 10_000,
  [ChainId.Katana]: 10_000,
  [ChainId.Cronos]: 10_000,
  [ChainId.Robinhood]: 10_000,
  [ChainId.Arc]: 10_000,
  [ChainId.Sepolia]: 10_000
}

export function getAlchemyMaxBlockRange(chainId: ChainId): number | undefined {
  return ALCHEMY_BLOCK_RANGES[chainId as AlchemyChainId]
}
